// src/App.js

import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, NavLink } from 'react-router-dom';
import './App.css';

import Home from './components/Home';
import KalkulatorMinuliTopli from './components/KalkulatorMinuliTopli';
import KalkulatorMinuliTopliTekstil from './components/KalkulatorMinuliTopliTekstil';
import KalkulatorMenadzerski from './components/KalkulatorMenadzerski';
import KalkulatorUgovorODjelu from './components/KalkulatorUgovorODjelu';
import KalkulatorAutorski from './components/KalkulatorAutorski';
import KalkulatorPrivremeniPovremeni from './components/KalkulatorPrivremeniPovremeni';
import KalkulatorZakup from './components/KalkulatorZakup';
import KalkulatorOstaliDohodak from './components/KalkulatorOstaliDohodak';
import KalkulatorDoprinosiNeoKom from './components/KalkulatorDoprinosiNeoKom';
import KalkulatorDoprinosiKomPIO from './components/KalkulatorDoprinosiKomPIO';
import KalkulatorDoprinosiKomNePIO from './components/KalkulatorDoprinosiKomNePIO';
import KalkulatorDoprinosiVlasnik from './components/KalkulatorDoprinosiVlasnik';
import KalkulatorDoprinosiSamostalno from './components/KalkulatorDoprinosiSamostalno';
import KalkulatorDatumStaza from './components/KalkulatorDatumStaza';
import KalkulatorPoreskaKamata from './components/KalkulatorPoreskaKamata';
import KalkulatorPlata from './components/KalkulatorPlata';
import KalkulatorFBIH from './components/KalkulatorFBIH';
import RS from './components/RS';

import O_nama from './pages/O_nama';
import Kontakt from './pages/Kontakt';
import PolitikaPrivatnosti from './pages/PolitikaPrivatnosti';
import UsloviKoristenja from './pages/UsloviKoristenja';
import KorisniLinkovi from './pages/KorisniLinkovi';
import PDV from './components/PDV';
import Kamata from './components/PoreskaKamata';
import UgovorORadu from './components/UgovorRad';
import Faktura from './components/Faktura';
import Dokumenti from './components/Dokumenti';

function App() {
  const [darkMode, setDarkMode] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem('theme') === 'dark';
    setDarkMode(saved);
    document.documentElement.setAttribute('data-theme', saved ? 'dark' : 'light');
  }, []);

  const toggleTheme = () => {
    const mode = !darkMode;
    setDarkMode(mode);
    document.documentElement.setAttribute('data-theme', mode ? 'dark' : 'light');
    localStorage.setItem('theme', mode ? 'dark' : 'light');
  };

  const toggleMenu = () => {
    setMenuOpen((prev) => !prev);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <BrowserRouter>
      <header className="app-header">
        <div className="logo-and-toggle">
          <a href="/" style={{ display: 'inline-block' }}>
          <img
            src="/logo.png"
            alt="Logo"
            className="app-logo"
            style={{ height: '80px'}}
          />
          </a>
          <h1 className="app-title">Web-portal za freelance knjigovođe u BiH</h1>
          <div className="header-controls">
            <button className="theme-toggle" onClick={toggleTheme} aria-label="Promijeni temu">
              {darkMode ? '☀️Svijetla tema' : '🌙Tamna tema'}
            </button>
            <button
              className="hamburger-btn"
              onClick={toggleMenu}
              aria-label={menuOpen ? 'Zatvori meni' : 'Otvori meni'}
            >
              <span className={menuOpen ? 'bar bar1 open' : 'bar bar1'} />
              <span className={menuOpen ? 'bar bar2 open' : 'bar bar2'} />
              <span className={menuOpen ? 'bar bar3 open' : 'bar bar3'} />
            </button>
          </div>
        </div>
        <nav className={menuOpen ? 'nav-menu open' : 'nav-menu closed'}>
          <NavLink
            to="/"
            className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
            onClick={closeMenu}
          >
            Obračuni
          </NavLink>
          <NavLink
            to="/dokumenti"
            className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
            onClick={closeMenu}
          >
            Izrada Dokumenata
          </NavLink>
          <NavLink
            to="/KorisniLinkovi"
            className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
            onClick={closeMenu}
          >
            Korisni linkovi
          </NavLink>
          <NavLink
            to="/politika-privatnosti"
            className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
            onClick={closeMenu}
          >
            Politika privatnosti
          </NavLink>
          <NavLink
            to="/uslovi-koristenja"
            className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
            onClick={closeMenu}
          >
            Uslovi korištenja
          </NavLink>
          <NavLink
            to="/o-nama"
            className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
            onClick={closeMenu}
          >
            O meni
          </NavLink>
          <NavLink
            to="/kontakt"
            className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
            onClick={closeMenu}
          >
            Kontakt
          </NavLink>
        </nav>
      </header>

      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/minuli-topli" element={<KalkulatorMinuliTopli />} />
          <Route path="/kalkulator-plata" element={<KalkulatorPlata />} />
          <Route path="/minuli-topli-tekstil" element={<KalkulatorMinuliTopliTekstil />} />
          <Route path="/menadzerski-ugovor" element={<KalkulatorMenadzerski />} />
          <Route path="/ugovor-o-djelu" element={<KalkulatorUgovorODjelu />} />
          <Route path="/autorski-ugovor" element={<KalkulatorAutorski />} />
          <Route path="/privremeni-povremeni" element={<KalkulatorPrivremeniPovremeni />} />
          <Route path="/zakup" element={<KalkulatorZakup />} />
          <Route path="/ostali-dohodak" element={<KalkulatorOstaliDohodak />} />
          <Route path="/doprinosi-nekom" element={<KalkulatorDoprinosiNeoKom />} />
          <Route path="/doprinosi-kom-pio" element={<KalkulatorDoprinosiKomPIO />} />
          <Route path="/doprinosi-kom-nepio" element={<KalkulatorDoprinosiKomNePIO />} />
          <Route path="/doprinosi-vlasnik" element={<KalkulatorDoprinosiVlasnik />} />
          <Route path="/doprinosi-samostalno" element={<KalkulatorDoprinosiSamostalno />} />
          <Route path="/datum-staza" element={<KalkulatorDatumStaza />} />
          <Route path="/poreska-kamata" element={<KalkulatorPoreskaKamata />} />
          <Route path="/o-nama" element={<O_nama />} />
          <Route path="/kontakt" element={<Kontakt />} />
          <Route path="/politika-privatnosti" element={<PolitikaPrivatnosti />} />
          <Route path="/uslovi-koristenja" element={<UsloviKoristenja />} />
          <Route path="/KorisniLinkovi" element={<KorisniLinkovi />} />
          <Route path="/kalkulator-FBIH" element={<KalkulatorFBIH />} />
          <Route path="/RS" element={<RS />} />
          <Route path="/pdv" element={<PDV />} />
          <Route path="/kamata" element={<Kamata />} />
          <Route path="/ugovor-o-radu" element={<UgovorORadu />} />
          <Route path="/faktura" element={<Faktura />} />
          <Route path="/dokumenti" element={<Dokumenti />} />
        </Routes>
      </main>

      <footer className="app-footer">
        <p>
          <strong>Kalkulator-Plata.com</strong> je vaša pouzdana platforma za
          precizno izračunavanje zarada i troškova rada u BiH. ©
          2025 Kalkulator-Plata.com. Sva prava zadržana.
        </p>
      </footer>
    </BrowserRouter>
  );
}

export default App;
